<template>
	<div :style='{"width": labelOnly ? "auto" : width, "max-width": labelOnly ? "auto" : width}'>
		<v-btn
			v-if='labelOnly'
			small
			text
			@click='showSelectDialog = true'
		>
			{{ label }}
			<v-icon class='ml-1'>
				far fa-angle-down
			</v-icon>
		</v-btn>
		<v-select
			v-else
			v-model='selection'
			:append-icon='iconOnly ? "far fa-angle-down" : "fal fa-angle-down"'
			:class='{
				"iconOnly": iconOnly,
			}'
			:dense='dense'
			:items='options'
			item-text='label'
			:menu-props='{ bottom: true, offsetY: true }'
			class='pa-0 ma-0'
			color='primary'
			flat
			hide-details
			outlined
			@click='$vuetify.breakpoint.mdAndDown ? showSelectDialog = true : ""'
		/>

		<v-dialog
			v-model='showSelectDialog'
			max-width='75%'
			scrollable
			style='max-height: 70%'
		>
			<v-card style='position: relative'>
				<v-toolbar
					color='beige'
					dense
					flat
					height='44px'
				>
					<v-toolbar-title class='primary--text font-weight-bold'>
						{{ title }}
					</v-toolbar-title>
					<v-spacer />
					<v-btn icon @click='showSelectDialog = false'>
						<v-icon size='18'>
							fas fa-times
						</v-icon>
					</v-btn>
				</v-toolbar>

				<v-card-text class='pa-0 px-1'>
					<v-list class='px-3 py-2'>

						<template
							v-for='(option, index) in options'
						>
							<v-list-item
								:key='option.value'
								@click='selection = option.value || option; showSelectDialog = false'
							>
								<span
									:class='selection === option || selection === option.value ? "font-weight-bold" : ""'
									style='font-size: 13px'
								>
									{{ option.label || option }}
								</span>


							</v-list-item>

							<v-divider v-if='index < options.length - 1' :key='index' class='mx-3' />
						</template>

					</v-list>
				</v-card-text>
			</v-card>


		</v-dialog>
	</div>
</template>

<script>
	export default {
		name: 'SelectComponent',

		props: {
			value: {
				required: true,
        type: [String, Number]
			},
			options: {
				required: true,
				type: Array
			},
			title: {
				default: 'Auswahl treffen:',
				type: String
			},
			dense: {
				default: false,
				type: Boolean
			},
			width: {
				default: 'auto',
				type: String
			},
			dropdownMenuMinWidth: {
				default: undefined,
				type: String
			},
			label: {
				default: '',
				type: String
			},
			labelOnly: {
				default: false,
				type: Boolean
			},
			iconOnly: {
				default: false,
				type: Boolean
			}
		},
    data() {
			return {
				showSelectDialog: false
			}
		},
		computed: {
		  nudgeTop() {
        let headerHeight = 0;
        if(document.getElementsByClassName('navbar').length > 0) {
          headerHeight += document.getElementsByClassName('navbar')[0].clientHeight
        }
        if(document.getElementsByClassName('header-bar').length > 0) {
          headerHeight += document.getElementsByClassName('header-bar')[0].clientHeight;
        }
        return headerHeight
      },
			selection: {
				get() {
					return this.value
				},
				set(val) {
					this.$emit('input', val)
				}
			}
		},

	}
</script>
